import React, { Component } from 'react';
import { Grid, Row, Col, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

export class Notes extends Component {
    render() {
        const { components } = this.props;

        if (0 === components.length) {
            return (
                <div>Nenhum elemento do tipo Observações encontrado!</div>
            )
        }

        return (
            <Grid fluid>
                {
                    components.map((component, idx) =>
                        <Row key={`notes-${idx}`}>
                            <Col>
                                <FormGroup controlId={`formNotes-${component.id}`}>
                                    <ControlLabel>Observações - {component.id}</ControlLabel>
                                    <FormControl
                                        componentClass="textarea"
                                        rows="6"
                                        className="notes-textarea"
                                        value={component.notes}
                                        placeholder="Introduza as observações"
                                        onChange={(e) => this.props.onChange(e, component.id)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    )}
            </Grid>
        )
    }
}
